import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { uiApplicationStatusTypes } from '../../constants/statusConstants';
import { getApplicationsTabPath } from '../../constants/urls';
import LandlordReview from './LandlordReview';
import { fetchListingData, loadApplicantsData } from '../../actions/initApplicationActionCreators';
import { getPropertyId } from '../../utils/route';
import { logError } from '@zg-rentals/log-error';

function mapDispatchToProps(dispatch, ownProps) {
  const { match = {}, history, location } = ownProps;
  const { params = {} } = match;
  const { applicationId } = params;
  const propertyId = getPropertyId(location);

  return {
    initLandlordReview: () => {
      const initDataPromise = dispatch(loadApplicantsData({ applicationId, listingId: propertyId }));
      initDataPromise
        .then((data) => {
          const { currentApplication = {} } = data;
          const { applicantsData = [] } = currentApplication;
          const firstApplicant = applicantsData[0] || {};
          const { statusType } = firstApplicant;

          // NOTE: if one applicant status is withdrawn, all are guaranteed to be withdrawn
          const withdrawn = statusType === uiApplicationStatusTypes.WITHDRAWN.id;

          if (withdrawn) {
            history.push(getApplicationsTabPath(propertyId));
          }
        })
        .catch((error) => {
          logError({
            error,
            context: 'Failed to load applicants data',
          });
        });
      dispatch(fetchListingData({ propertyId }));
    },
  };
}

const enhance = compose(withRouter, connect(null, mapDispatchToProps));

export default enhance(LandlordReview);
